import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GlobalService } from '../../shared/services/global.service';
import { fromEvent, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MenuService } from '../services/menu.service';
import { environment } from '../../../environments/environment';
import { LoginService } from '../services/login.service';

@Component({
    selector: 'app-menu-bar',
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuBarComponent implements OnInit {
	uploadFiles = [];
	subs: Subscription[] = [];
	activeMenu: any = [];
	menuIsOpen: boolean = false;
	wasClose: boolean = true;
	menuColor = environment.mainColor;
	loading: boolean = false;
	contentSub: Subscription;
	projectId: string;

	toggleMenu() {
		this.menuIsOpen = !this.menuIsOpen;
		if (this.wasClose) {  //ipad fix
			this.menuIsOpen = true;
			this.wasClose = false;
		}
		this.onContentEnter();
	}

  showSubMenu(pageName) {
    const page = this.activeMenu.find((page) => page.name === pageName);
    if (page) {
      return page.showSubMenu;
    }

    return false;
  }

  hideAllSubMenus() {
    this.activeMenu.forEach((page) => {
      page.showSubMenu = false;
    });
  }

  toggleShowSubMenu(pageName, show) {
      this.activeMenu.forEach((page) => {
        if (page.name === pageName) {
          page.showSubMenu = show;
        }
      });
  }

	showMenu(value) {
		this.wasClose = !this.menuIsOpen; //ipad fix
		this.menuIsOpen = value;
		this.onContentEnter();
	}

	imageLoad(ev) {
	}

	getUser() {
		if (this._gS.user) {
			return this._gS.user.surename[0].toUpperCase() + this._gS.user.given_name[0].toLowerCase()
		}
		return '--'
	}

	getUserLong() {
		if (this._gS.user) {
			return this._gS.user.surename.toUpperCase() + ', ' + this._gS.user.given_name.toLowerCase()
		}
		return '--'
	}

	logout() {
		this.loading = true;
		sessionStorage.removeItem('lv-session');
		this._lS.logout().subscribe(
			data => {
				this._gS.removeCookies();
				this.loading = false;
				this.router.navigate(['/login']);
			},
			err => {
				this._gS.removeCookies();
				this.loading = false;
				this.router.navigate(['/login']);
			}
		);
	}

	onContentEnter() {
		let section = document.querySelector('.content');
		if (this.contentSub) {
			this.contentSub.unsubscribe();
		}
		if (!this.menuIsOpen || !section) {
			return;
		}
		this.contentSub = fromEvent(section, 'mouseover').subscribe(
			data => {
				if (this.menuIsOpen) {
					this.menuIsOpen = false;
					this.wasClose = true;
					this.contentSub.unsubscribe();
				}
			}
		);
	}

	onChangesRoute() {
		this.subs.push(this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			map((x) => {
				this.menuIsOpen = false;
				this.onContentEnter();
				return this._mS.getDataFromRoute('menu');
			}),
		).subscribe((menuName: string | null) => {
			this.activeMenu = this._mS.getMenu(menuName);
		}));
	}

	onClickLink() { 
		this.menuIsOpen = false;
		
	}

	onChangesManualMenu() {
		this.subs.push(this._mS.manualChangeMenu$.subscribe(menuName => {
			if (menuName) {
				setTimeout(() => {
					this.activeMenu = this._mS.getMenu(menuName);
				}, 100)
			}
		}));
	}

	trackByName(index, item) {
		return item.name;
	}

	constructor(
		private _lS: LoginService,
		private _mS: MenuService,
		public _gS: GlobalService,
		private router: Router) { }

	ngOnInit() {
		this.onChangesRoute();
		this.onChangesManualMenu();
	}

	ngOnDestroy() {
		this.subs.map(s => s.unsubscribe());
	}

}
